export default __webpack_public_path__ + "static/media/icon-sitting.5dd8f092.svg";